// extracted by mini-css-extract-plugin
export default {"host":"AlertMessage_host__t+H3U"};